import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { motion } from 'framer-motion';

const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const location = useLocation();

  const navItems = [
    { path: '/about', label: { tc: '我們的故事', cn: '我们的故事', en: 'Our Story' } },
    { path: '/products', label: { tc: '我們的海鮮', cn: '我们的海鲜', en: 'Our Seafood' } },
    { path: '/awards', label: { tc: '為何選我們', cn: '为何选我们', en: 'Why Choose Us' } },
    { path: '/blog', label: { tc: '最新動態', cn: '最新动态', en: 'Latest News' } },
    { path: '/contact', label: { tc: '與我們聯絡', cn: '与我们联络', en: 'Contact Us' } },
  ];

  return (
    <header 
      className="glass sticky top-0 z-50" 
      data-testid="main-header"
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
            <motion.img 
              src="https://customer-assets.emergentagent.com/job_freshcatch-5/artifacts/b5in0ucy_logo.jpg"
              alt="Shukee Seafood Logo"
              className="h-12 w-auto"
              whileHover={{ scale: 1.05 }}
              data-testid="logo-image"
            />
            <motion.h1 
              className="text-2xl font-bold gradient-text hidden sm:block"
              whileHover={{ scale: 1.05 }}
              data-testid="logo-text"
            >
              {language === 'tc' ? '樹記海鮮' : language === 'cn' ? '树记海鲜' : 'SHUKEE SEAFOOD'}
            </motion.h1>
          </Link>

          <nav className="flex items-center gap-4 md:gap-8 overflow-x-auto" data-testid="main-nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-xs md:text-sm font-medium transition-colors hover:text-primary whitespace-nowrap ${
                  location.pathname === item.path ? 'text-primary' : 'text-foreground'
                }`}
                data-testid={`nav-link-${item.path.slice(1)}`}
              >
                {item.label[language]}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Button
              onClick={() => toggleLanguage('tc')}
              className={`rounded-full px-3 py-1 text-sm ${
                language === 'tc' 
                  ? 'bg-gradient-to-r from-primary to-secondary text-white' 
                  : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
              }`}
              data-testid="language-tc-btn"
            >
              繁
            </Button>
            <Button
              onClick={() => toggleLanguage('cn')}
              className={`rounded-full px-3 py-1 text-sm ${
                language === 'cn' 
                  ? 'bg-gradient-to-r from-primary to-secondary text-white' 
                  : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
              }`}
              data-testid="language-cn-btn"
            >
              简
            </Button>
            <Button
              onClick={() => toggleLanguage('en')}
              className={`rounded-full px-3 py-1 text-sm ${
                language === 'en' 
                  ? 'bg-gradient-to-r from-primary to-secondary text-white' 
                  : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
              }`}
              data-testid="language-en-btn"
            >
              EN
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;